import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-820b4a82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p1" }
const _hoisted_2 = {
  key: 0,
  class: "p3 small-text-error"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "p1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "p3 small-text-error"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "p-d-flex p-flex-column p-ai-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icons/challenges/student/empty-state.svg",
  alt: "empty state"
}, null, -1))
const _hoisted_11 = { class: "p-text-center p-mt-3 p2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert_circle = _resolveComponent("alert-circle")!
  const _component_icon = _resolveComponent("icon")!
  const _component_card = _resolveComponent("card")!

  return (_ctx.courseStarted)
    ? (_openBlock(), _createBlock(_component_card, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("dl", {
            class: _normalizeClass({ multipleabsents: _ctx.absents.completed > 9 })
          }, [
            _createElementVNode("dt", null, [
              _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.faltasCopy), 1),
              (_ctx.absentsExceeded)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.copies.errorMessage), 1))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.absentsExceeded)
              ? (_openBlock(), _createElementBlock("dd", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.absents.completed, (i) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: i,
                      src: "/assets/icons/classes/used-fault.svg",
                      alt: "used-fault",
                      class: "fault-icon"
                    }))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxAbsents - _ctx.absents.completed, (i) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: i,
                      src: "/assets/icons/classes/available-fault.svg",
                      alt: "available-fault",
                      class: "fault-icon"
                    }))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("dd", _hoisted_4, [
                  _createVNode(_component_icon, { strokeColor: "var(--error)" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_alert_circle)
                    ]),
                    _: 1
                  })
                ])),
            _createElementVNode("dt", _hoisted_5, [
              _createElementVNode("div", null, [
                (_ctx.deliversOnTime)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.copies.challengeSuccess), 1))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.copies.challengeError), 1),
                      (!_ctx.deliversOnTime)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.copies.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ], 64))
              ]),
              _createElementVNode("img", {
                src: `/assets/icons/classes/${_ctx.deliversOnTime ? '' : 'not-'}ontime-challenge.svg`,
                alt: "deliveredchallenge",
                class: "deliveries-challenge"
              }, null, 8, _hoisted_8)
            ])
          ], 2)
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_card, {
        key: 1,
        bgDark: "",
        border: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.copies.notStarted), 1)
          ])
        ]),
        _: 1
      }))
}